// @flow

import ProjectClient from "../lib/apiClients/roofSnapApiClient/projectClient";
import { CALL_API } from "../middleware/api";
import {
    GET_PROJECT_FAILURE,
    GET_PROJECT_REQUEST,
    GET_PROJECT_SUCCESS
} from "./actionTypes";

export const getProject = (id: string) => {
    const projectClient = new ProjectClient('v1');
    const request = projectClient.getProject;

    return {
        [CALL_API]: {
            types: [
                GET_PROJECT_REQUEST,
                GET_PROJECT_SUCCESS,
                GET_PROJECT_FAILURE,
            ],
            request,
            params: {
                id
            }
        },
    };
};
